/* @flow */

import clsx from 'clsx';
import * as React from 'react';

import type { Profile } from '../../../helpers/profiles/typesAndConstants';
import type { ModalState } from '../../../redux/modal/reducers';

import ProfilesManager from '../../../helpers/profiles/profilesManager';
import Avatar from '../../profiles/Avatar';
import { AvatarSize, DisplayNamePlacement } from '../../profiles/types';
import Modal, { ModalView } from '../modal';
import './ProfileSplashscreenModal.css';

// In case animation doesn't start (and ends), modal will close after this time (in ms)
const FALLBACK_TIMEOUT = 4_000;

export type ProfileSplashscreenModalStateType = {
  currentProfile: Profile | null,
  isAnimated: boolean,
};

class ProfileSplashscreenModal extends React.PureComponent<ModalState, ProfileSplashscreenModalStateType> {
  fallbackTimer: TimeoutID;
  modal: ModalView | null;

  constructor(props: ModalState) {
    super(props);

    this.state = {
      currentProfile: ProfilesManager.getCurrentProfile(),
      isAnimated: false,
    };

    this.fallbackTimer = setTimeout(() => this.modal?.close(), FALLBACK_TIMEOUT);
  }

  handleOnAnimationEnd = (): void => {
    if (this.fallbackTimer !== null) {
      clearTimeout(this.fallbackTimer);
    }

    this.modal?.close();
  };

  handleAvatarOnLoaded = (): void => {
    this.setState({ isAnimated: true });
  };

  renderContent = (): React.Node => {
    const { currentProfile, isAnimated } = this.state;

    if (currentProfile === null) {
      // Shouldn't happen since this modal is called only if there's a previously selected profile
      return null;
    }

    const { avatarId, id, name } = currentProfile;

    return (
      <div className={clsx('profileSplashscreenMessageContent', isAnimated && 'animated')} onAnimationEnd={this.handleOnAnimationEnd}>
        <Avatar avatarId={avatarId} displayName={DisplayNamePlacement.Bottom} isDisabled name={name} onLoaded={this.handleAvatarOnLoaded} profileId={id} size={AvatarSize.Big} />
      </div>
    );
  };

  setModalRef = (instance: ModalView | null) => {
    this.modal = instance;
  };

  render(): React.Node {
    return (
      <Modal canCloseOnEscape={false} canCloseOnOverlayClick={false} className='profileSplashscreen' hasBackgroundImage hasCloseButton={false} innerRef={this.setModalRef} skipAnimation>
        {this.renderContent()}
      </Modal>
    );
  }
}

export default ProfileSplashscreenModal;
